import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { com } from '@eidu/form'
import { EntityTypesContext } from '../../io/context/EntityTypes'
import LoadingOverlay from '../../components/feedback/LoadingOverlay'
import { requireNotUndefinedOrNull } from '../../util/require'
import EntityTypeNotAccessibleError from './EntityTypeNotAccessibleError'
import CreateOrEditPage from './CreateOrEditPage'
import CreateOrEditFormPage from './CreateFormPage'

import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind

const EditEntityRoute = () => {
  const params = useParams()
  const entityTypeId = entityTypeIdFromString(requireNotUndefinedOrNull(params.entityTypeId))

  const entityTypeRepository = useContext(EntityTypesContext)
  const entityType = entityTypeRepository.useItem(entityTypeId)
  const error = entityTypeRepository.useError()
  const loading = entityTypeRepository.useLoading()

  if (loading && !entityType) return <LoadingOverlay isOpen />
  if (!entityType || error) return <EntityTypeNotAccessibleError />

  return entityType.kind === EntityTypeKind.Form ? <CreateOrEditFormPage /> : <CreateOrEditPage />
}

export default EditEntityRoute
